import uuidv4 from 'uuid/v4';

export default class SecureRandom {
    public static generate(byteCount: number): Uint8Array {
        const buffer: Uint8Array = new Uint8Array(byteCount);
        crypto.getRandomValues(buffer);
        return buffer;
    }

    public static getUUID(): string {
        // Just in case: We override the random of the library with really random values
        const random = Array.from(SecureRandom.generate(16));
        return uuidv4({random});
    }

}
